import React from 'react';

export const Email = ({ color }) => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2770_3773)">
      <path
        d="M9.97307 7.35377L15.1472 4.23639C15.2494 4.17472 15.3628 4.1338 15.4808 4.11595C15.5989 4.09811 15.7193 4.10369 15.8351 4.13239C15.951 4.16108 16.0601 4.21233 16.1562 4.28319C16.2522 4.35406 16.3334 4.44316 16.395 4.5454L16.3969 4.54813C16.5207 4.75411 16.5579 5.00077 16.5003 5.23412C16.4428 5.46747 16.2951 5.66851 16.0897 5.79326L10.0094 9.48412L10.004 9.49321L4.07824 5.92323C3.87497 5.79733 3.72949 5.59639 3.67335 5.36397C3.61721 5.13155 3.65492 4.88637 3.7783 4.68156C3.90169 4.47676 4.10082 4.32882 4.33253 4.26982C4.56424 4.21082 4.80986 4.2455 5.01618 4.36636L9.97307 7.35377ZM2.7295 0.470093H17.2712C18.7726 0.470093 19.9978 1.69523 19.9978 3.19666V14.1029C19.9978 15.6044 18.7726 16.8295 17.2712 16.8295H2.7295C1.22807 16.8295 0.00292969 15.6044 0.00292969 14.1029L0.0120182 3.19666C0.0120182 1.69432 1.22807 0.470093 2.7295 0.470093ZM2.7295 2.2878C2.48988 2.28972 2.26076 2.38638 2.09218 2.55667C1.92359 2.72696 1.82924 2.95704 1.82973 3.19666L1.82064 14.1029C1.82064 14.601 2.23144 15.0118 2.7295 15.0118H17.2712C17.7692 15.0118 18.18 14.601 18.18 14.1029V3.19666C18.18 2.69861 17.7692 2.2878 17.2712 2.2878H2.7295Z"
        fill={color ?? '#005EE0'}
      />
    </g>
    <defs>
      <clipPath id="clip0_2770_3773">
        <rect
          width="20"
          height="16.3594"
          fill="white"
          transform="translate(0 0.470093)"
        />
      </clipPath>
    </defs>
  </svg>
);
